import { toast as toastifyToast } from 'react-toastify';

const clearToastQueue = () => {
  toastifyToast.dismiss();
  if (typeof toastifyToast.clearWaitingQueue === 'function') {
    toastifyToast.clearWaitingQueue();
  }
};

const show = (type, message, options = {}) => {
  clearToastQueue();

  if (type && typeof toastifyToast[type] === 'function') {
    return toastifyToast[type](message, options);
  }

  return toastifyToast(message, options);
};

const toast = {
  show,
  success: (message, options) => show('success', message, options),
  error: (message, options) => show('error', message, options),
  info: (message, options) => show('info', message, options),
  warn: (message, options) => show('warn', message, options),
  dismiss: (...args) => toastifyToast.dismiss(...args),
  clearWaitingQueue: (...args) => toastifyToast.clearWaitingQueue(...args),
};

export default toast;